module.exports = __webpack_public_path__ + "static/media/trivia-round1.6a578d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/trivia-round1.png
// module id = 2678
// module chunks = 0